// Single source of truth for a brief's response tally (admin questions tweak
// brief §1). The live defect it fixes: counting `recipient.status ===
// 'responded'` on its own misses a supplier who has SUBMITTED a response but
// whose recipient row hasn't flipped to 'responded' yet — so the rail read
// "0 of 4 responded" while the activity log showed a submitted quote, and the
// "yet to respond" figure disagreed with both. Same class of bug as the
// compliance desync (brief-compliance-review-loop §1): two places counting the
// same fact, one of them wrong.
//
// A recipient counts as RESPONDED if their status is 'responded' OR they appear
// in the submitted-response set. Withdrawn recipients aren't "sent". Everything
// derives here so every surface reconciles:
//   sent        — non-withdrawn recipients
//   responded   — submitted (by status or by response row)
//   declined    — status 'declined'
//   pending     — not yet accepted, not submitted
//   accepted    — accepted but not yet submitted
//   outstanding — pending + accepted (i.e. "yet to respond")
export function deriveResponseCounts(recipients = [], submittedSupplierIds = new Set()) {
  const ids = submittedSupplierIds instanceof Set ? submittedSupplierIds : new Set(submittedSupplierIds || []);
  const isResponded = (r) => r.status === 'responded' || ids.has(r.supplier_id);
  let sent = 0, responded = 0, declined = 0, pending = 0, accepted = 0;
  for (const r of recipients) {
    if (r.status === 'withdrawn') continue;
    sent += 1;
    if (r.status === 'declined') { declined += 1; continue; }
    if (isResponded(r)) { responded += 1; continue; }
    if (r.status === 'pending') pending += 1;
    else accepted += 1; // accepted (or any other non-terminal) but not yet submitted
  }
  return { sent, responded, declined, pending, accepted, outstanding: pending + accepted };
}
